import { createDataAttributes } from '@/app/utils/createDataAttributes';

const buildYoutubeEmbed = (id: string, autoplay: boolean, muted: boolean) => {
  const params = new URLSearchParams({
    rel: '0',
    modestbranding: '1',
    enablejsapi: '1',
    autoplay: autoplay ? '1' : '0',
    mute: muted ? '1' : '0',
  });
  return `https://www.youtube.com/embed/${id}?${params.toString()}`;
};

interface YoutubeIframeProps {
  id: string;
  title?: string;
  className?: string;
  autoplay?: boolean;
  muted?: boolean;
}
export const YoutubeIframe = ({
  id,
  title,
  className,
  autoplay = false,
  muted = false,
}: YoutubeIframeProps) => {
  if (!id) return null;

  return (
    <iframe
      src={buildYoutubeEmbed(id, autoplay, muted)}
      title={title || 'YouTube video player'}
      allow="autoplay; encrypted-media; picture-in-picture"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
      className={className}
      {...createDataAttributes({
        test: 'youtube-iframe',
      })}
    />
  );
};
